import { isString, isNumber } from "../predicates";

export const getLocalStringDate = (date: Date | string | number): string => {
  const value = isString(date) || isNumber(date) ? new Date(date) : date;

  return value.toLocaleDateString("en-US", {
    hour12: false,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
